<template>
  <path :d="set(data)" :stroke-width="strokeWidth" :stroke="stroke"></path>
</template>

<script>
import * as shape from 'd3-shape'

export default {
  name: 'Line',
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    strokeWidth: {
      type: Number,
      default: 2
    },
    stroke: {
      type: String,
      default: 'currentcolor'
    },
    scaleX: {
      type: Function,
      default () {
        return function () {}
      }
    },
    scaleY: {
      type: Function,
      default () {
        return function () {}
      }
    },
    keyX: {
      type: String,
      default: 'x'
    },
    keyY: {
      type: String,
      default: 'y'
    }
  },
  computed: {
    set () {
      return shape
      .line()
      .x((d, i) => this.scaleX(i))
      .y((d) => this.scaleY(d[this.keyY]))
      // .curve(shape.curveBundle)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// Line.vue?ff73ed82